<script setup lang="ts">
  import { MpCard } from '@borg/ui';
  import { JobDetailsSource, JobGroup, JobSimple } from '@borg/types';

  const props = withDefaults(
    defineProps<{
      item: JobGroup | JobSimple;
      source?: JobDetailsSource;
      showExpiredLabel?: boolean;
    }>(),
    {
      source: undefined,
      showExpiredLabel: true,
    },
  );

  const jobCard = useJobCard.provide();
  jobCard.set(props.item, props.source);
</script>

<template>
  <MpCard
    class="job-card"
    border="light-only"
  >
    <JobCardTags />
    <JobCardTitle />
    <JobCardSubtitle />
    <JobCardLocation />
    <JobCardDate :show-expired-label="props.showExpiredLabel" />
    <slot />
  </MpCard>
</template>

<style scoped lang="scss">
  .job-card {
    display: flex;
    flex-direction: column;
    gap: var(--mp-space-30);
  }
</style>
